<template>
  <div>
    <sweet-modal blocking width="780px" ref="createProjectTaskProgress" class="modal" v-on:close="close">
      <h1>Add Progress Note</h1>
      <!--{{selectedRow}}<br>-->
      <!--{{formCreateProjectTaskProgress.progress}}-->
      <el-form label-position="left" :model="formCreateProjectTaskProgress" status-icon :rules="rules" ref="formCreateProjectTaskProgress" label-width="100px" class="demo-ruleForm">
        <el-form-item class="text-block" label-position="top" label-width="0" label="Text">
          <vue-editor
                  useCustomImageHandler
                  @image-added="handleImageAdded"
                  v-model="formCreateProjectTaskProgress.text"></vue-editor>
          <!--<el-input type="textarea" placeholder="Text" v-model="formCreateProjectTaskProgress.text"></el-input>-->
        </el-form-item>
        <div class="reminder-block">

          <el-form-item label="Time spent">
            <!-- <el-time-picker
              v-model="formCreateProjectTaskProgress.timeSpent"
              value-format='HHmm'
              format='HH:mm'
              :picker-options="{
                align: 'center'
              }"
              placeholder="Arbitrary time">
            </el-time-picker> -->
            <el-input disabled placeholder="Arbitrary time" v-model="stopTime"></el-input>
          </el-form-item>

          <!-- <div class="reminder-block_date">
            <el-form-item prop="isReminderActive" label="Set Reminder" label-width="100px">
              <el-checkbox name="type" v-model="formCreateProjectTaskProgress.isReminderActive"></el-checkbox>
            </el-form-item>
            <el-form-item prop="reminderDate" label-width="20px">
              <el-date-picker
                      :disabled="!formCreateProjectTaskProgress.isReminderActive"
                      v-model="formCreateProjectTaskProgress.reminderDate"
                      type="date"
                      placeholder="Pick a date"
                      value-format="ddMMyyyy"
              >
              </el-date-picker>
            </el-form-item>
          </div> -->
          <!--<el-button slot="trigger" v-on:click="$refs.formReminder.open()" size="small" type="primary">Set Reminder</el-button>-->
        </div>
        <!--<el-button slot="trigger" size="small" type="primary">Add Media</el-button>-->
        <!-- <div class="upload-media">
          <el-upload
                  class="upload-demo"
                  ref="upload"
                  action=""
                  :auto-upload="false"
                  :file-list="fileList">
            <el-button slot="trigger" size="small" type="primary">Add Media</el-button>
          </el-upload>
        </div> -->
        <el-form-item label="Progress" prop="Progress" >
          <el-slider
                  v-model="formCreateProjectTaskProgress.progress"
                  :max="90"
                  :min="0"
                  :step="10"
                  show-stops>
          </el-slider>
        </el-form-item>
        <!-- <el-form-item label="Hours spent">
          <el-input placeholder="Hours spent" v-model="formCreateProjectTaskProgress.hoursSpent"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="Minutes spent">
          <el-input placeholder="Minutes spent" v-model="formCreateProjectTaskProgress.minutesSpent"></el-input>
        </el-form-item> -->
        <div class="flex-twocolumn">
            <el-form-item label-width="0">
              <el-switch v-model="formCreateProjectTaskProgress.notifyProjectTeam"></el-switch> Notify Management
            </el-form-item>
            <el-form-item label-width="0">
              <el-switch v-model="formCreateProjectTaskProgress.notifyTaskTeam"></el-switch> Notify Task Team
            </el-form-item>
            <el-form-item label-width="0">
              <el-switch :disabled="allowNotification" v-model="formCreateProjectTaskProgress.notifyClients"></el-switch> Notify Clients
            </el-form-item>
            <el-form-item label-width="0">
              <el-switch :disabled="allowNotification" v-model="formCreateProjectTaskProgress.notifyVendors"></el-switch> Notify Vendors
            </el-form-item>
        </div>
        <div class="flex-end">
          <el-form-item>
            <el-button @click="createProjectTaskProgressSubmit('formCreateProjectTaskProgress')" class="modal__btn" type="primary" plain size="mini">Add</el-button>
          </el-form-item>
        </div>
      </el-form>
      <!--{{allowNotification}}-->
    </sweet-modal>
    <!--<sweet-modal blocking  ref="formReminder" v-on:close="closeReminder">-->
      <!--<el-form :model="formReminder">-->
        <!--<el-form-item>-->
          <!--<vue-editor v-model="formReminder.description"></vue-editor>-->
        <!--</el-form-item>-->
        <!--<el-form-item>-->
          <!--<el-button @click="setReminderSubmit" class="modal__btn" type="primary" plain size="medium">Set reminder</el-button>-->
        <!--</el-form-item>-->
      <!--</el-form>-->
    <!--</sweet-modal>-->
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue';

import axios from 'axios';

export default {
  components: {
    SweetModal,

    VueEditor
  },
  props: [
    'selectedRow',
    'activeProjectId',
    'allowNotification',
    'stopTime',
  ],
  mounted() {
    this.createProjectTaskProgressOpen();
    // this.formCreateProjectTaskProgress.progress = this.selectedRow.progress
  },
  data() {
    return {
        projectTaskId: 0,
        projectTaskTimerId: 0,
        formCreateProjectTaskProgress: {
        progress: 0,
        text: '',
        timeSpent: '0000',
        hoursSpent: 0,
        minutesSpent: 0,
        notifyProjectTeam: false,
        notifyTaskTeam: true,
        notifyClients: false,
        notifyVendors: false,
        isReminderActive: false,
        reminderDate: ''
      },
      // formReminder:{
      //   reminder:'',
      //   description:''
      // },
      fileList:[],
      rules: {
      }
    };
  },
  methods: {
    // formated(){
    //   return this.selectedRow.progress.toString() + '%'
    // },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type,
      });
    },

    createProjectTaskProgressOpen() {
    },

    createProjectTaskProgressSubmit(form) {
      if(this.formCreateProjectTaskProgress.progress < this.selectedRow.progress){
        return this.notification("Notification", "Progress cannot be less", "info")
      }
      console.log('---', 'submit create');
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();

          if (this.formCreateProjectTaskProgress.timeSpent) {
            let time, hours, minutes;
            time = this.formCreateProjectTaskProgress.timeSpent;
            hours = time.slice(0, 2);
            minutes = time.slice(2, 4);
            this.formCreateProjectTaskProgress.hoursSpent = hours
            this.formCreateProjectTaskProgress.minutesSpent = minutes
          }
          if(this.formCreateProjectTaskProgress.reminderDate === ''){
            this.formCreateProjectTaskProgress.reminderDate = null
          }
          axios
          .post(`/api/v1/projectTaskTimers/stop?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.projectTaskId}&projectTaskTimerId=${this.projectTaskTimerId}`, {
            text: this.formCreateProjectTaskProgress.text,
            progress: this.formCreateProjectTaskProgress.progress,
            notifyProjectTeam: this.formCreateProjectTaskProgress.notifyProjectTeam,
            notifyTaskTeam: this.formCreateProjectTaskProgress.notifyTaskTeam,
            notifyClients: this.formCreateProjectTaskProgress.notifyClients,
            notifyVendors: this.formCreateProjectTaskProgress.notifyVendors,
          })
          .then(response => {
            this.$store.dispatch('getTimerList')
            let data = {'taskId': this.projectTaskId, 'projectId': this.activeProjectId}
            this.$store.dispatch('getProgressesList', data)
            this.notification(this.$i18n.t('notification_title_success'), this.$i18n.t('success_addProgressNote'), "success");
            loader.hide()
            this.$refs.createProjectTaskProgress.close();
          })
          .catch(error => {
            loader.hide()
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    close(){
      // this.formCreateProjectTaskProgress.progress = 0
      this.formCreateProjectTaskProgress.text = ''
      this.formCreateProjectTaskProgress.hoursSpent = 0
      this.formCreateProjectTaskProgress.minutesSpent = 0
      this.formCreateProjectTaskProgress.notifyProjectTeam = false
      this.formCreateProjectTaskProgress.notifyTaskTeam = true
      this.formCreateProjectTaskProgress.notifyClients = false
      this.formCreateProjectTaskProgress.notifyVendors = false
      this.formCreateProjectTaskProgress.reminderDate = ''
      this.formCreateProjectTaskProgress.isReminderActive = false
      this.formCreateProjectTaskProgress.timeSpent = '0000'
    },
    // closeReminder(){
    //   this.formReminder.description = ''
    //   this.formReminder.reminder = ''
    // },
    // setReminderSubmit(){
    //   console.log('SET REMINDER')
    //     axios
    //             .post(`/api/v1/reminders/create`, {
    //               date: this.formReminder.reminder,
    //               text: this.formReminder.description,
    //               entityType: localStorage.getItem('selectedProjectId'),
    //               entityId: this.selectedRow.id
    //             })
    //             .then(response => {
    //               if(response.data.success){
    //                 this.$refs.formReminder.close();
    //                 this.notification("Success", "Reminder successfully sent", "success");
    //                 console.log("reminder response", response.data)
    //               }
    //             })
    //             .catch(error => {
    //               loader.hide()
    //               this.$refs.formReminder.close();
    //               this.notification("Notification", error.response.data.message, "info")
    //             });
    // },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      let loader = this.$loading.show();
      console.log("FILE",file);
      // this.form.imageUrl = URL.createObjectURL(file.raw);
      // console.log('---', this.form.imageUrl);
      var formData = new FormData();
      formData.append('file', file);

      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
              .then(response => {
                let url = response.data.fileUrl // Get url from response
                Editor.insertEmbed(cursorLocation, 'image', url);
                resetUploader();
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              })
    }
  },
  watch:{
    // selectedRow(sed){
    //   console.log(sed)
    //   this.formCreateProjectTaskProgress.progress = sed.progress
    // },
    'selectedRow.progress': function (val) {
      this.formCreateProjectTaskProgress.progress = val
    }
  }
};

</script>

<style lang="less" scoped>
  .text-block{
    display:flex;
    flex-direction:column;
  }
  .reminder-block{
    justify-content: space-between;
    display:flex;
    &_date{
      display:flex;
    }
  }
  .reminder-datepicker{
    margin-left:0;
  }
  .flex-twocolumn{
    display:flex;
    &_second-column{
      margin-left:20px;
    }
  }
  .flex-end{
    display:flex;
    justify-content:flex-end;
  }
  .sweet-modal-overlay{
    z-index:1000;
  }
  /*.remider{*/
    /*display:flex;*/
    /*justify-content:flex-end;*/
    /*margin-bottom:10px;*/
  /*}*/
  .upload-media{
    display:flex;
    justify-content:flex-end;
  }

  .modal {
    color: #000000;
  }
</style>

<style lang="less">
  .flex-twocolumn{
    display:flex;
    .el-form-item__content{
      margin:0 12px;
      font-size:13px;
    }
  }
  .reminder-block{
    .el-date-editor.el-input{
      width: 160px;
    }
  }
</style>
